export function phoneDigits(input: string | null | undefined) {
  return String(input || "").replace(/\D/g, "").slice(0, 10);
}

export function formatPhoneVisual(input: string | null | undefined) {
  const digits = phoneDigits(input);
  if (!digits) return "";
  if (digits.length <= 3) return digits;
  if (digits.length <= 6) return `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
  return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6, 10)}`;
}
